module.exports = __webpack_public_path__ + "static/media/pinterest.49179e4f.svg";